import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["demand", "row", "message", "notice"]
  static values = { planUrl: String, conflict: String, category: String, pick: String }

  dragStart(event) {
    this.select(event.currentTarget)
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", event.currentTarget.dataset.orderId)
  }

  allowDrop(event) {
    if (this.picked) event.preventDefault()
  }

  drop(event) {
    event.preventDefault()
    this.plan(event.currentTarget)
  }

  pick(event) {
    const block = event.currentTarget
    if (this.picked === block) return this.clear()

    this.select(block)
    this.rowTargets.forEach((row) => row.setAttribute("tabindex", "0"))
    this.announce(this.pickValue)
  }

  choose(event) {
    if (!this.picked || event.target.closest("a, button, form")) return
    this.plan(event.currentTarget)
  }

  chooseByKey(event) {
    if (event.key === "Escape") return this.clear()
    if (event.key !== "Enter" && event.key !== " ") return
    event.preventDefault()
    this.choose(event)
  }

  select(block) {
    this.clear()
    this.picked = block
    block.setAttribute("aria-pressed", "true")
  }

  clear() {
    this.picked?.setAttribute("aria-pressed", "false")
    this.picked = null
    this.rowTargets.forEach((row) => row.removeAttribute("tabindex"))
  }

  plan(row) {
    const block = this.picked
    if (!block) return

    if (block.dataset.categoryId !== row.dataset.categoryId) return this.refuse(this.categoryValue)
    if (this.overlaps(block, row)) return this.refuse(this.conflictValue)

    const url = new URL(this.planUrlValue, window.location.origin)
    url.searchParams.set("selected", block.dataset.orderId)
    url.searchParams.set("preselect", row.dataset.resourceId)
    url.hash = "planning_panel"
    this.clear()
    Turbo.visit(url.toString(), { frame: "content-turbo-frame" })
  }

  overlaps(block, row) {
    const starts = Number(block.dataset.starts)
    const ends = Number(block.dataset.ends)
    const busy = JSON.parse(row.dataset.busy || "[]")
    return busy.some(([from, until]) => from < ends && until > starts)
  }

  refuse(text) {
    this.clear()
    this.noticeTarget.textContent = text
    this.noticeTarget.classList.remove("hidden")
    this.announce(text)
  }

  announce(text) {
    this.messageTarget.textContent = text
  }
}
